import React from "react";
import { Row, Col, Drawer } from "antd";
import POSLogo from "../../../../assets/images/cwPosLogo.png";
import MobileIcon from "../../../../assets/images/mobileIcon.svg";
import userIcon from "../../../../assets/images/salesRep.svg";
import data from "../../../../constants/retailPos.json";

const SideMenuDrawer = ({
  sideMenuDrawervisible,
  onClose,
  handleOmsOrders,
  cart,
  posConfig,
  handleSalesReturnFromSideMenu,
}) => {
  return (
    <Drawer title={<img src={POSLogo} style={data.posScreenStyles.header.posLogoIcon} alt="" />} placement="left" onClose={onClose} open={sideMenuDrawervisible}>
      <Row style={{ paddingLeft: "20px" }}>
        <Col span={2}>
          <img src={MobileIcon} alt="Mobile Icon" style={{ width: "10px" }} />
        </Col>
        <Col span={22}>
          <p
            style={{
              marginBottom: 0,
              fontSize: "14px",
              fontWeight: "normal",
              fontFamily: "Inter",
              letterSpacing: "0px",
              color: "#000000",
              opacity: 1,
              cursor: "pointer",
            }}
            onClick={handleOmsOrders}
          >
            OMS Orders
          </p>
        </Col>
      </Row>
      <Row style={{ paddingLeft: "20px", paddingTop: "20px" }}>
        <Col span={2}>
          <img src={userIcon} alt="Mobile Icon" style={{ width: "15px" }} />
        </Col>
        <Col span={22}>
          <p
            style={{
              marginBottom: 0,
              fontSize: "14px",
              fontWeight: "normal",
              fontFamily: "Inter",
              letterSpacing: "0px",
              color: "#000000",
              opacity: 1,
              cursor: "pointer",
            }}
          >
            {cart?.customer?.name}&nbsp; &nbsp;
            {cart?.customer?.retlLoyaltyBalance || 0}
          </p>
        </Col>
      </Row>
      <div
        style={{
          display: posConfig?.showSalesReturn === "Y" ? "block" : "none",
        }}
      >
        <Row style={{ paddingLeft: "20px", paddingTop: "20px" }}>
          <Col span={2}>
            <img src={userIcon} alt="Mobile Icon" style={{ width: "15px" }} />
          </Col>
          <Col span={22}>
            <p
              style={{
                marginBottom: 0,
                fontSize: "14px",
                fontWeight: "normal",
                fontFamily: "Inter",
                letterSpacing: "0px",
                color: "#000000",
                opacity: 1,
                cursor: "pointer",
              }}
              onClick={handleSalesReturnFromSideMenu}
            >
              Sales Return
            </p>
          </Col>
        </Row>
      </div>
    </Drawer>
  );
};

export default SideMenuDrawer;
